import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import {
  getAllModGroupsWithDescriptions,
  getValidCartItems,
} from '../utils/cart';

const selectCart = (state: RootState) => state.cart;
const selectCartModality = createSelector(selectCart, (cart) => cart.modality);
const selectCartItems = createSelector(selectCart, (cart) => cart.cartItems);
const selectCartItemsQuantity = createSelector(
  selectCart,
  (cart) => cart.cartItemsQuantity
);

const selectValidCartItems = createSelector(selectCartItems, (cartItems) =>
  getValidCartItems(cartItems)
);
const selectHypothesisCartItems = createSelector(
  selectCart,
  (cart) => cart.hypothesisCartItems
);

const selectCartLoyalties = createSelector(
  selectCart,
  (cart) => cart.loyalties
);

const selectModGroupsWithDescriptions = createSelector(
  selectCartItems,
  (cartItems) => getAllModGroupsWithDescriptions(cartItems)
);

export {
  selectCart,
  selectCartItems,
  selectCartItemsQuantity,
  selectCartModality,
  selectValidCartItems,
  selectHypothesisCartItems,
  selectCartLoyalties,
  selectModGroupsWithDescriptions,
};
